<template>
	<button
		class="relative btn p-3 bg-white w-full text-primary-superdark text-start rounded-xl border border-gray flex items-center hover:bg-gray-light focus:bg-gray-light"
		:title="props.item.channel.channelName"
		@click.prevent="openChat()"
	>
		<div class="grow min-w-px">
			<p class="truncate">{{ props.item.channel.channelName }}</p>
			<p
				:class="['text-sm font-light text-gray-dark truncate']"
				v-html="highlightedText"
			></p>
		</div>
		<aside class="shrink-0 self-start ps-3">
			<div class="text-sm text-end text-gray-darker font-light text-nowrap">
				<time :datetime="props.item.created" :title="renderedDate">
					{{ renderedDate }}
				</time>
			</div>
		</aside>
	</button>
</template>

<script setup lang="ts">
import type { Props } from '@/types/ChatListSearchItem'
import { useRouter } from 'vue-router'
import { formatDate } from '@/services/dateTimeService'
import { computed } from 'vue'
import { wrapSubstrings } from '@/services/markText'
const router = useRouter()
const props = defineProps<Props>()

const openChat = () => {
	router.push({
		name: 'Chat',
		params: { channelId: props.item.channel.channelId },
		state: {
			scrollToSession: props.item.sessionId,
			scrollToMessage: props.item.messageIndex
		}
	})
}

const renderedDate = computed<string>(() => {
	return formatDate(props.item.created, {
		autoFormat: true
	})
})

const highlightedText = computed<string>(() => {
	if (!props.item.messageTextPreview) return ''

	const highlightStart = props.item.stringStartIndexPreview
	const highlightEnd = props.item.stringEndIndexPreview

	return wrapSubstrings(props.item.messageTextPreview, [
		{
			start: Number(highlightStart),
			end: Number(highlightEnd)
		}
	])
})
</script>

<style scoped></style>
